import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'react-bootstrap';
import { IQuoteActions } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {Email} from '../../../../components/Email';

import { Player } from 'video-react';

interface IPrelaunchProps {
  actions: {
    quote: IQuoteActions;
  };
}

class Prelaunch extends React.Component<IPrelaunchProps> {

  public render() {
    return (
      <div className="front-page animated fadeIn prelaunch">
        <div className="container">
          <Row>
            <Col sm={12}>
              <h2>SITE EN CONSTRUCTION</h2>
              <br/>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <p>
                Notre solution de souscription en ligne <strong>e</strong>RCpro sera bientôt disponible.
              </p>
              <p>
                Dédiée à la RC Professionnelle et Garantie Financière des intermédiaires en assurance,
                banque et immobilier réalisant jusqu’à 750 000 € de chiffres d’affaires annuel,
                découvrez dès à présent les avantages de notre plateforme en regardant cette vidéo :
              </p>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Player
                autoPlay={true}
              >
                <source src="https://s3-eu-west-1.amazonaws.com/msamlin-uat2/files/msAmlin_OUT_180912_v01.mp4" />
              </Player>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <br/>
              <p>
                Pour être informé de l’ouverture de notre plateforme, écrivez à
                <Email email={'rcpro.france@msamlin.com'}/>.
              </p>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <p>
                Pour en savoir plus sur MS Amlin, visitez notre site
                <a href="https://www.msamlin.com/en/markets/France.html" target="_blank"> msamlin.com/france</a>.
              </p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    actions: {
      quote: bindActionCreators({ ...quoteActions }, dispatch),
    },
  }),
)(Prelaunch);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Prelaunch/index.tsx